import React from 'react'
import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useAccounts from '../../hooks/useAccounts'
import HomeLocationWidget from './HomeLocationWidget'
import HomePreferredLocation from './HomePreferredLocation'
import HomeUnlockPreferredPricing from './HomeUnlockPreferredPricing'

const HomeSidebar = () => {
  const { isLoadingPotentialTeams } = useAccounts()
  if (isLoadingPotentialTeams) {
    return <SkeletonLoadingHomeSidebar />
  }

  return (
    <Box>
      <HomeLocationWidget />
      <Box marginY={4} marginX={-3}>
        <HomePreferredLocation />
        <HomeUnlockPreferredPricing />
      </Box>
    </Box>
  )
}

const SkeletonLoadingWidget = () => {
  return (
    <>
      <Skeleton height={40} width={150} />
      <Skeleton width={210} />
      <Skeleton width={210} />
    </>
  )
}

export const SkeletonLoadingHomeSidebar = () => (
  <Box>
    <SkeletonLoadingWidget />
    <SkeletonLoadingWidget />
    <Skeleton height={70} width={150} />
  </Box>
)

export default HomeSidebar
